import { __extends } from 'tslib';
import web2clientSounds from '@lst/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import { getPositionOnViewport } from '../../helpers/position.js';
import Tooltip from '../Tooltip/Tooltip.js';
import TooltipBody from '../Tooltip/TooltipBody.js';
import TooltipDecoratorClass from '../Tooltip/TooltipDecorator.js';
import styles from './ContextMenu.module.scss.js';
import ContextMenuItem from './ContextMenuItem.js';

var ContextMenu = (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemsClickHandlers = new WeakMap();
        _this.state = {
            isActive: false,
            left: _this.props.position.x,
            top: _this.props.position.y,
            onContextMenuStateChange: _this.props.onContextMenuStateChange,
        };
        _this.hide = function () {
            if (_this.state.isActive) {
                var isActive = false;
                _this.setState({ isActive: isActive });
                _this.props.onContextMenuStateChange(isActive);
            }
        };
        _this.onClick = function (event, item) {
            event.stopPropagation();
            if (!item.disabled) {
                _this.hide();
                web2clientSounds.playButtonSound();
                _this.props.onItemClick(item.value);
            }
        };
        _this.onEscape = function (e) {
            if (e.keyCode === 27 && _this.state.isActive) {
                e.preventDefault();
                _this.hide();
            }
        };
        return _this;
    }
    ContextMenu.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.left !== nextProps.position.x || prevState.top !== nextProps.position.y) {
            var isActive = !!(nextProps.position.x && nextProps.position.y);
            prevState.onContextMenuStateChange(isActive);
            return {
                isActive: isActive,
                left: nextProps.position.x,
                top: nextProps.position.y,
            };
        }
        return null;
    };
    ContextMenu.prototype.componentDidUpdate = function () {
        var position = getPositionOnViewport(this._contextMenu, {
            top: this.state.top,
            left: this.state.left,
        });
        if (position.left !== this.state.left || position.top !== this.state.top) {
            this.setState({
                left: position.left,
                top: position.top,
            });
        }
        this._contextMenu.focus();
    };
    ContextMenu.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.onEscape, true);
    };
    ContextMenu.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.onEscape, true);
    };
    ContextMenu.prototype.renderDivider = function (isNeedDivider) {
        return isNeedDivider ? React.createElement("div", { className: styles.divider }) : null;
    };
    ContextMenu.prototype.renderMenuItems = function (items) {
        var _this = this;
        return items.map(function (item, index) {
            if (!item) {
                return null;
            }
            var tooltip = null;
            if (item.tooltip) {
                tooltip = (React.createElement(Tooltip, null,
                    React.createElement(TooltipBody, null, item.tooltip)));
            }
            var ContextMenuItemWithDecorator = TooltipDecoratorClass()(ContextMenuItem);
            var clickHandler = _this.itemsClickHandlers.get(item);
            if (!clickHandler) {
                clickHandler = function (e) { return _this.onClick(e, item); };
                _this.itemsClickHandlers.set(item, clickHandler);
            }
            return (React.createElement(ContextMenuItemWithDecorator, { key: index, onClick: clickHandler, tooltipBody: tooltip, name: item.name, disabled: item.disabled }));
        });
    };
    ContextMenu.prototype.renderMenu = function () {
        var _this = this;
        return this.props.context.map(function (context, index) {
            return (React.createElement("div", { key: index },
                _this.renderDivider(context.isNeedDivider),
                _this.renderMenuItems(context.items)));
        });
    };
    ContextMenu.prototype.render = function () {
        var _a;
        var _this = this;
        var classNameMenu = classNames(styles.menu, this.props.className, (_a = {},
            _a[styles.isDropped] = this.state.isActive,
            _a[styles.isDemo] = this.props.isDemo,
            _a));
        var style = {
            top: this.state.top,
            left: this.state.left,
        };
        return (React.createElement("div", { className: classNameMenu, tabIndex: 1, onBlur: this.hide, ref: function (c) {
                if (c) {
                    _this._contextMenu = c;
                }
            }, style: style },
            React.createElement("div", { className: styles.inner }, this.renderMenu())));
    };
    ContextMenu.defaultProps = {
        onContextMenuStateChange: function () { return null; },
    };
    return ContextMenu;
}(React.PureComponent));

export { ContextMenu as default };
//# sourceMappingURL=ContextMenu.js.map
